// extracted by mini-css-extract-plugin
export default {"container":"I2RyxM","viewer":"qaMmUx","truncated":"QZrUXa","expandTransition":"Bl_5ku","shrinkTransition":"osTpkR","showMore":"VOx2B5"};